import isAnImageType from "../utils/isAnImageType.util";
import React, {JSX, LazyExoticComponent, ReactElement, ReactNode} from "react";
import CustomIconType from "../assets/icons";
import {AxiosResponse, isAxiosError} from "axios";

export class CustomHelper {
    static isBooleanString(value: string) {
        return ["true", "false"].includes(value.toLowerCase());
    }

    static isEmail(value: string) {
        var validRegex =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return validRegex.test(value)
    }

    static hasMax(value: string, length: number) {
        return (value).trim().length <= length;
    }

    static hasMin(value: string, length: number) {
        return (value).trim().length >= length;
    }

    static renderIcon = (icon?: string | JSX.Element | LazyExoticComponent<React.FC<CustomIconType>> | ReactNode, iconClassName?: string) => {
        if (typeof icon === 'string' && isAnImageType(icon)) {
            return React.createElement("img", {
                src: icon,
                className: iconClassName || "",
                alt: "icon"
            })
        } else if (React.isValidElement(icon)) {
            return React.cloneElement(icon as React.ReactElement<any>, {
                className: `${iconClassName || ""} icon`
            })
        } else if (icon as React.LazyExoticComponent<React.FC<CustomIconType>>) {
            const IconComponent = icon as React.LazyExoticComponent<React.FC<CustomIconType>>;
            return React.createElement(IconComponent, {
                className: iconClassName || ""
            });
        }
        return null;
    }

    static cx(...classes: Array<string | false | null | undefined>) {
        return classes.filter(Boolean).join(" ");
    }

    static capitalizeFirstWord(word: string): string {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
     static getInitials(name: string) {
        if (!name) return "";
        const parts = name.trim().split(" ");
        if (parts.length === 1) return parts[0][0].toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    static throwErrorResponse(err: any, defaultErrorMessage?: string) {
        if (isAxiosError(err) && err.response) {
            return {
                status: err.response.status,
                message: err.response.data?.message || err.message,
                success: false,
                data: undefined
            };
        }
        return {
            status: 400,
            message: err.message || defaultErrorMessage || "Unknown error",
            success: false,
            data: undefined

        };
    }

    static appendQueryParamIfDefined(url: URLSearchParams, key: string, value?: string | number | null) {
        if (value !== undefined && value !== null) {
            url.set(key, String(value));
        }
    }

    static async makeApiRequest(apiCall: () => any, runOnClose?: () => void) {
        try {
            const result = await apiCall();
            const responseData = result?.data;

            return {
                success: responseData?.status ?? true,
                data: responseData?.data ?? responseData,
                message:
                    typeof responseData?.message === "object"
                        ? responseData.message[0]
                        : responseData?.message,
            };
        } catch (err: any) {
            const anyErr = err as any;

            const axiosData = isAxiosError(anyErr)
                ? anyErr.response?.data ?? (anyErr as any)?.raw?.response?.data
                : undefined;

            return {
                success: false,
                errors: axiosData?.errors,
                data: axiosData?.data ?? axiosData,
                message:
                    typeof axiosData?.message === "object"
                        ? axiosData.message[0]
                        : axiosData?.message || (anyErr as Error).message || "Something went wrong",
            };
        } finally {
            runOnClose?.();
        }
    }

    static formatDate(date: string | Date): string {
        return new Date(date).toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
        });
    }

    static getDescription(description?: string, data_plan?: any): string {
        return description ?? `${data_plan ? "Data" : "Airtime"} Top Up`;
    }
}
